import { combineReducers } from 'redux';
import AuthReducer from './authReducer';
import ConfigReducer from './configReducer';

export default combineReducers({
  auth: AuthReducer,
  config: ConfigReducer,
});
